<template>
  <BaseChoice
    title="関連付けるコースを選択してください"
    resourceType="course"
    :fields="fields"
    :items="course.courses"
    :totalItems="totalCourses"
    :isFetching="isFetching"
  />
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import BaseChoice from '@/views/choices/Base.vue';

export default {
  data() {
    return {
      isFetching: false,
    };
  },
  components: {
    BaseChoice,
  },
  mounted() {
    let filterBy = {};

    if (this.prevFormData.corporation) {
      filterBy.corporationId = this.prevFormData.corporation.id;
    }

    if (this.prevFormData.brand) {
      filterBy.brandId = this.prevFormData.brand.id;
    }

    this.$logger.debug('Start fetching Course for Choices');
    this.clearCourses();
    this.isFetching = true;
    this.fetchCourses({ data: { filterBy } }).then(() => {
      this.isFetching = false;
      this.$logger.debug('Done fetching Course for Choices');
    });
  },
  computed: {
    fields() {
      return [
        {
          key: 'uid',
          label: 'コースID',
          sortable: true,
          thAttr: { width: 150 },
        },
        {
          key: 'name',
          label: 'コース名',
          sortable: true,
          thAttr: { width: 150 },
        },
        {
          key: 'testPassingScore',
          label: '確認テスト合格点数',
          sortable: true,
          thAttr: { width: 120 },
        },
        {
          key: 'choiceResource',
          label: '選択',
          sortable: false,
          thAttr: { width: 60 },
        },
      ];
    },
    ...mapState(['course']),
    ...mapGetters('course', ['totalCourses']),
    ...mapState('form', ['prevFormData']),
  },
  methods: {
    ...mapActions('course', ['fetchCourses', 'clearCourses']),
  },
};
</script>
